import React from 'react'
import { Route, Switch } from 'react-router'
import { ELD_ROUTES } from 'apps/fleet-planner/components/eld-integration'
import { EldIntegrationCallbackPage, EldIntegrationWizardPage } from '../eld-integration'

export const IntegrationsPage = () => {
  return (
    <Switch>
      <Route
        exact
        path={[ELD_ROUTES.connect.location, ELD_ROUTES.importTrucks.location]}
        component={EldIntegrationWizardPage}
      />
      {/**
       * ELD Integration Callback
       */}
      <Route exact path={ELD_ROUTES.callback.location} component={EldIntegrationCallbackPage} />
    </Switch>
  )
}
